<template>
  <Container
    v-loading="loading"
    :element-loading-text="$t('main_home_micro_loading')"
    element-loading-spinner="el-icon-loading"
    class="custom-loading"
  >
    <TabMenu />
    <!-- 微应用容器区域 - 添加loading状态和文本 -->
    <el-main>
      <div
        v-for="item in microAppBox"
        :key="item.name"
        :id="item.container.slice(1)"
        v-show="$route.path.startsWith(item.activeRule)"
        class="layout-container"
      ></div>
      <Home v-show="$route.path === '/'"></Home>
    </el-main>
  </Container>
</template>

<script>
import { computed, defineComponent, watch } from 'vue'
import Container from '@/components/Layout/Container.vue'
import TabMenu from '@/components/Layout/TabMenu.vue'
import Home from '@/views/Home.vue'
import { useRoute, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import { $t } from '@/lang'

export default defineComponent({
  name: 'Application',
  components: { Container, Home, TabMenu },
  setup() {
    // 状态定义
    const route = useRoute()
    const store = useStore()

    // 计算属性
    const microAppBox = computed(() => store.state.microApp.microApps)
    const loading = computed(
      () => store.state.menu.menuLoading || store.state.microApp.microLoading
    )

    // 微应用加载逻辑
    watch(
      () => route.path,
      async () => {
        try {
          await store.dispatch('microApp/setMicroApp', route.path)
          store.commit('microApp/updateMicroCacheList')
        } catch (error) {
          console.error('微应用加载失败:', error)
        }
      },
      { flush: 'post', immediate: true }
    )

    // 路由离开处理
    onBeforeRouteLeave(() => {
      store.dispatch('microApp/checkAppStatus')
      return new Promise(resolve => setTimeout(resolve, 400))
    })

    return { microAppBox, loading }
  }
})
</script>

<style lang="scss" scoped>
/* 自定义loading样式 */
// ::v-deep .custom-loading {
//   position: relative;
//   height: 100%;
// }

/* 更直接地针对loading遮罩元素 */
::v-deep .el-loading-mask {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
}

::v-deep .el-loading-spinner .el-loading-text {
  font-size: 18px; /* 增大字体大小 */
  font-weight: 500;
  margin-top: 15px; /* 调整文本位置 */
}

::v-deep .el-loading-spinner .el-icon-loading {
  font-size: 36px; /* 增大加载图标 */
}

// /* 确保遮罩覆盖整个容器 */
// ::v-deep .custom-loading .el-loading-mask {
//   z-index: 9999;
// }

#layout-container {
  height: 100%;
}
.el-main {
  padding: 10px;
}
</style>

<style lang="scss">
.layout-container {
  height: 100%;
  > * {
    height: 100%;
  }
}
</style>
